import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enUSTranslation from './locales/en-US/translation.json';
import ptBRTranslation from './locales/pt-BR/translation.json';
import jaJPTranslation from './locales/ja-JP/translation.json';
import zhCNTranslation from './locales/zh-CN/translation.json';

export const langList = [
  {
    detectedValue: 'en-US',
    label: 'English',
    shortHand: 'EN'
  },
  {
    detectedValue: 'pt-BR',
    label: 'Português',
    shortHand: 'PT'
  },
  {
    detectedValue: 'ja-JP',
    label: '日本語',
    shortHand: 'JA'
  }
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      convertDetectedLanguage: (lng) => {
        // 定义语言到默认地区的映射
        const languageToRegionMap = {
          en: 'en-US',
          pt: 'pt-BR',
          ja: 'ja-JP',
          zh: 'zh-CN'
        };

        // 如果已经是语言-地区格式 (如 pt-BR) 直接返回
        if (lng.includes('-')) return lng;

        // 否则，查找默认地区
        const languageOnly = lng.split('-')[0];
        return (
          languageToRegionMap[
            languageOnly as keyof typeof languageToRegionMap
          ] || lng
        );
      }
    },
    resources: {
      'en-US': {
        translation: enUSTranslation
      },
      'pt-BR': {
        translation: ptBRTranslation
      },
      'ja-JP': {
        translation: jaJPTranslation
      },
      'zh-CN': {
        translation: zhCNTranslation
      }
    },
    fallbackLng: langList[0].detectedValue,
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
